import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { clientsEndpoint, jobsEndpoint } from "../constants";
import CandidateSubmissionImage from "../assets/Candidate Submission.jpg";

const ClientDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("job-details");
  const [activeSidebarTab, setActiveSidebarTab] = useState("company-info");
  const [loading, setLoading] = useState(true);
  const [showNudgeModal, setShowNudgeModal] = useState(false);
  const [nudgeMessage, setNudgeMessage] = useState("");
  const [sendingNudge, setSendingNudge] = useState(false);
  const [selectedNudgeTarget, setSelectedNudgeTarget] = useState(null);

  const [showCheckInModal, setShowCheckInModal] = useState(false);
  const [checkInData, setCheckInData] = useState({
    candidateId: null,
    candidateName: "",
    subject: "",
    message: "",
  });
  const [sendingCheckIn, setSendingCheckIn] = useState(false);

  const [submissionForm, setSubmissionForm] = useState({
    candidateId: "",
    roleId: "",
    hideContactDetails: true,
    includeShortlistLink: true,
  });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [roles, setRoles] = useState([]);

  const [clientData, setClientData] = useState({
    id: 1,
    name: "Morph & Mind",
    industry: "IT Services & IT Consulting",
    locations: ["New York, NY, USA", "San Francisco, CA, USA"],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    employeeCount: "50 - 200 Employees",
    metrics: {
      totalSubmissions: 1503,
      interviewsArranged: 1200,
      hiresMade: 100,
      avgTimeToFill: "20 days",
      feedbackScore: 4.5,
    },
    financials: {
      fee: "30%",
      expectedDealValue: "$30,000",
    },
    contacts: [
      {
        id: 1,
        name: "Josh doe",
        position: "CEO",
        avatar: "/avatars/josh.jpg",
        emails: ["joshdoe@gmail.com", "joshdoe@outlook.com"],
        phone: "+1 (458) 532 2382",
      },
      {
        id: 2,
        name: "John doe",
        position: "VP Sales",
        avatar: "/avatars/john.jpg",
        emails: ["johndoe@gmail.com", "johndoe@outlook.com"],
        phone: "+1 (458) 532 2382",
      },
      {
        id: 3,
        name: "Jane Smith",
        position: "Marketing Director",
        avatar: "/avatars/jane.jpg",
        emails: ["janesmith@gmail.com", "janesmith@hotmail.com"],
        phone: "+1 (202) 555 0147",
      },
      {
        id: 4,
        name: "Michael Johnson",
        position: "CTO",
        avatar: "/avatars/michael.jpg",
        emails: ["mjohnson@techmail.com", "mike.johnson@company.com"],
        phone: "+1 (303) 555 0198",
      },
      {
        id: 5,
        name: "Sarah Williams",
        position: "HR Manager",
        avatar: "/avatars/sarah.jpg",
        emails: ["swilliams@company.com", "sarah.w@outlook.com"],
        phone: "+1 (415) 555 0276",
      },
    ],
    jobs: [
      {
        id: 1,
        title: "UX UI Designer",
        status: "open",
        aiMatchQuality: 90,
        remote: true,
        jobType: "Full-time",
        level: "Intermediate",
        description:
          "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do euismod te...",
        submissionStatus: "Submitted",
        feedbackAlert: {
          type: "warning",
          message: "No feedback for 4 days",
        },
      },
      {
        id: 2,
        title: "UX UI Designer",
        status: "open",
        aiMatchQuality: 90,
        remote: true,
        jobType: "Full-time",
        level: "Intermediate",
        description:
          "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do euismod te...",
        submissionStatus: "Submitted",
        feedbackAlert: {
          type: "success",
          message: "Feedback given right now",
        },
      },
      {
        id: 3,
        title: "UX UI Designer",
        status: "open",
        aiMatchQuality: 90,
        remote: true,
        jobType: "Full-time",
        level: "Intermediate",
        description:
          "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do euismod te...",
        submissionStatus: "Submitted",
        feedbackAlert: {
          type: "warning",
          message: "No feedback for 4 days",
        },
      },
      {
        id: 4,
        title: "UX UI Designer",
        status: "open",
        aiMatchQuality: 90,
        remote: true,
        jobType: "Full-time",
        level: "Intermediate",
        description:
          "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do euismod te...",
        submissionStatus: "Submitted",
        feedbackAlert: {
          type: "warning",
          message: "No feedback for 4 days",
        },
      },
    ],
    candidates: [
      {
        id: 1,
        name: "John doe",
        aiMatchScore: 90,
        status: "Submitted",
        submittedAt: "Oct 20, 2025 | 10:58 AM",
        skills: [
          { label: "Strong skills", type: "positive" },
          { label: "Weaker culture fit", type: "negative" },
        ],
        activities: [
          {
            id: 1,
            user: "John doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
          {
            id: 2,
            user: "Jane doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
        ],
      },
      {
        id: 2,
        name: "John doe",
        aiMatchScore: 90,
        status: "Submitted",
        submittedAt: "Oct 20, 2025 | 10:58 AM",
        skills: [
          { label: "Strong skills", type: "positive" },
          { label: "Weaker culture fit", type: "negative" },
        ],
        activities: [
          {
            id: 1,
            user: "John doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
          {
            id: 2,
            user: "Jane doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
        ],
      },
      {
        id: 3,
        name: "John doe",
        aiMatchScore: 90,
        status: "Submitted",
        submittedAt: "Oct 20, 2025 | 10:58 AM",
        skills: [
          { label: "Strong skills", type: "positive" },
          { label: "Weaker culture fit", type: "negative" },
        ],
        activities: [
          {
            id: 1,
            user: "John doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
          {
            id: 2,
            user: "Jane doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
        ],
      },
      {
        id: 4,
        name: "John doe",
        aiMatchScore: 90,
        status: "Submitted",
        submittedAt: "Oct 20, 2025 | 10:58 AM",
        skills: [
          { label: "Strong skills", type: "positive" },
          { label: "Weaker culture fit", type: "negative" },
        ],
        activities: [
          {
            id: 1,
            user: "John doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
          {
            id: 2,
            user: "Jane doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
        ],
      },
      {
        id: 5,
        name: "John doe",
        aiMatchScore: 90,
        status: "Submitted",
        submittedAt: "Oct 20, 2025 | 10:58 AM",
        skills: [
          { label: "Strong skills", type: "positive" },
          { label: "Weaker culture fit", type: "negative" },
        ],
        activities: [
          {
            id: 1,
            user: "John doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
          {
            id: 2,
            user: "Jane doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
        ],
      },
      {
        id: 6,
        name: "John doe",
        aiMatchScore: 90,
        status: "Submitted",
        submittedAt: "Oct 20, 2025 | 10:58 AM",
        skills: [
          { label: "Strong skills", type: "positive" },
          { label: "Weaker culture fit", type: "negative" },
        ],
        activities: [
          {
            id: 1,
            user: "John doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
          {
            id: 2,
            user: "Jane doe",
            date: "Thu | Oct 21, 2025 | 10:56 AM",
            text: "We are looking for UX UI Designer for our company. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eius...",
          },
        ],
      },
    ],
  });

  useEffect(() => {
    const fetchClientDetail = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const response = await fetch(`${clientsEndpoint}${id}/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch client details');
        }

        const data = await response.json();
        setClientData(data);
      } catch (error) {
        console.error('Error fetching client details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClientDetail();
  }, [id]);

  const handleAddNote = async () => {
    try {
      const token = localStorage.getItem('token');
      const noteContent = prompt('Enter your note:');

      if (!noteContent) return;

      const response = await fetch(`${clientsEndpoint}${id}/notes/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ content: noteContent }),
      });

      if (!response.ok) {
        throw new Error('Failed to add note');
      }

    } catch (error) {
      console.error('Error adding note:', error);
    }
  };

  const handleSendNudge = (target = null) => {
    setSelectedNudgeTarget(target);
    setNudgeMessage("");
    setShowNudgeModal(true);
  };

  const sendNudge = async (method) => {
    setSendingNudge(true);
    try {
      const token = localStorage.getItem('token');
      const endpoint = selectedNudgeTarget?.jobId
        ? `${jobsEndpoint}${selectedNudgeTarget.jobId}/nudge/`
        : `${clientsEndpoint}${id}/nudge/`;

      await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: nudgeMessage,
          method: method,
        }),
      });

      setShowNudgeModal(false);
      setNudgeMessage("");
      setSelectedNudgeTarget(null);
    } catch (error) {
      console.error('Error sending nudge:', error);
    } finally {
      setSendingNudge(false);
    }
  };

  const handleAddRole = () => {
    window.location.href = '/create-job';
  };

  const handleOpenCheckIn = (candidate) => {
    setCheckInData({
      candidateId: candidate.id,
      candidateName: candidate.name,
      subject: "",
      message: "",
    });
    setShowCheckInModal(true);
  };

  const sendCheckIn = async (scheduleForLater = false) => {
    setSendingCheckIn(true);
    try {
      const token = localStorage.getItem('token');
      await fetch(`${clientsEndpoint}${id}/candidates/${checkInData.candidateId}/check-in/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subject: checkInData.subject,
          message: checkInData.message,
          schedule_for_later: scheduleForLater,
        }),
      });
      setShowCheckInModal(false);
      setCheckInData({ candidateId: null, candidateName: "", subject: "", message: "" });
    } catch (error) {
      console.error('Error sending check-in:', error);
    } finally {
      setSendingCheckIn(false);
    }
  };

  const fetchRolesForSubmission = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${jobsEndpoint}?client=${id}`, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      setRoles(data.results || data || []);
    } catch (error) {
      console.error('Error fetching roles:', error);
    }
  };

  useEffect(() => {
    if (activeTab === 'hiring-pipeline') {
      fetchRolesForSubmission();
    }
  }, [activeTab]);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0]);
    }
  };

  const handleFileInput = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0]);
    }
  };

  const handleFileUpload = (file) => {
    const validTypes = ['image/svg+xml', 'image/png', 'image/jpeg', 'image/gif', 'application/pdf'];
    if (!validTypes.includes(file.type)) {
      alert('Please upload SVG, PNG, JPG, GIF or PDF file');
      return;
    }
    setUploadedFile(file);
  };

  const removeFile = () => {
    setUploadedFile(null);
  };

  const handleSubmission = async () => {
    if (!submissionForm.roleId) {
      
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const formPayload = new FormData();
      formPayload.append('client-id', id);
      formPayload.append('role-id', submissionForm.roleId);
      formPayload.append('hide-contact-details', submissionForm.hideContactDetails);
      formPayload.append('include-shortlist-link', submissionForm.includeShortlistLink);
      if (uploadedFile) {
        formPayload.append('branded_cv', uploadedFile);
      }

      const response = await fetch(`${jobsEndpoint}submissions/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formPayload,
      });

      if (response.ok) {
        setSubmissionForm({ candidateId: '', roleId: '', hideContactDetails: true, includeShortlistLink: true });
        setUploadedFile(null);
      } else {
        throw new Error('Failed to send submission');
      }
    } catch (error) {
      console.error('Error submitting:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleJobNudge = async (jobId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${jobsEndpoint}${jobId}/nudge/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to send job nudge');
      }

    } catch (error) {
      console.error('Error sending job nudge:', error);
    }
  };

  const renderStars = (score) => {
    return (
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            className={`w-5 h-5 ${
              index < Math.floor(score)
                ? "text-yellow-400 fill-current"
                : "text-gray-300"
            }`}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="p-4 md:p-6 flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#19bfb7]"></div>
          <p className="mt-4 text-gray-600">Loading client details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6">
      <div className="bg-white rounded-xl border border-gray-200">
        <div className="p-4 md:p-6 border-b border-gray-200">
          <div className="flex flex-col lg:flex-row items-start gap-4 lg:justify-between">
            <div className="flex items-start gap-3 md:gap-4 w-full lg:w-auto">
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-purple-600 flex items-center justify-center flex-shrink-0">
                <svg
                  className="w-6 h-6 md:w-8 md:h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <h1 className="text-xl md:text-2xl font-semibold text-gray-900 break-words">
                  {clientData.name}
                </h1>
                <p className="text-xs md:text-sm text-gray-600 mt-1">
                  {clientData.industry}
                </p>
                <div className="flex flex-wrap gap-2 md:gap-3 mt-2 md:mt-3">
                  {clientData.locations.map((location, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-1.5 md:gap-2 text-xs md:text-sm text-gray-600"
                    >
                      <svg
                        className="w-3 h-3 md:w-4 md:h-4 text-gray-400 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <span className="break-words">{location}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2 md:gap-3 w-full lg:w-auto">
              <button
                onClick={handleAddNote}
                className="flex-1 sm:flex-none px-3 md:px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap"
              >
                Add Note
              </button>
              <button
                onClick={handleSendNudge}
                className="flex-1 sm:flex-none px-3 md:px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap"
              >
                Send Nudge
              </button>
              <button
                onClick={handleAddRole}
                className="flex-1 sm:flex-none px-3 md:px-4 py-2 text-sm text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] cursor-pointer whitespace-nowrap"
              >
                Add Role
              </button>
            </div>
          </div>

          <div className="flex gap-4 md:gap-6 mt-4 md:mt-6 border-b border-gray-200 overflow-x-auto">
            <button
              onClick={() => setActiveTab("job-details")}
              className={`pb-3 text-xs md:text-sm font-medium whitespace-nowrap ${
                activeTab === "job-details"
                  ? "text-[#19bfb7] border-b-2 border-[#19bfb7]"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Job Details
            </button>
            <button
              onClick={() => setActiveTab("candidateList")}
              className={`pb-3 text-xs md:text-sm font-medium whitespace-nowrap ${
                activeTab === "candidateList"
                  ? "text-[#19bfb7] border-b-2 border-[#19bfb7]"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Candidate List
            </button>
            <button
              onClick={() => setActiveTab("hiring-pipeline")}
              className={`pb-3 text-xs md:text-sm font-medium whitespace-nowrap ${
                activeTab === "hiring-pipeline"
                  ? "text-[#19bfb7] border-b-2 border-[#19bfb7]"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              Candidate Submission
            </button>
          </div>
        </div>

        <div className="p-4 md:p-6">
          {activeTab === "job-details" && (
            <>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 mb-6">
                <div className="bg-white border border-gray-200 rounded-lg p-4 md:p-5">
                  <p className="text-xs text-gray-500 uppercase font-semibold">
                    Total Submissions
                  </p>
                  <p className="text-2xl md:text-3xl font-semibold text-gray-900 mt-3">
                    {clientData.metrics.totalSubmissions}
                  </p>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-4 md:p-5">
                  <p className="text-xs text-gray-500 uppercase font-semibold">
                    Interviews Arranged
                  </p>
                  <p className="text-2xl md:text-3xl font-semibold text-gray-900 mt-3">
                    {clientData.metrics.interviewsArranged}
                  </p>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-4 md:p-5">
                  <p className="text-xs text-gray-500 uppercase font-semibold">
                    Hires Made
                  </p>
                  <p className="text-2xl md:text-3xl font-semibold text-gray-900 mt-3">
                    {clientData.metrics.hiresMade}
                  </p>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-4 md:p-5">
                  <p className="text-xs text-gray-500 uppercase font-semibold">
                    Avg Time-to-Fill
                  </p>
                  <p className="text-2xl md:text-3xl font-semibold text-gray-900 mt-3">
                    {clientData.metrics.avgTimeToFill}
                  </p>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-4 md:p-5 col-span-2 md:col-span-1">
                  <p className="text-xs text-gray-500 uppercase font-semibold">
                    Feedback Score
                  </p>
                  <div className="flex items-center gap-2 mt-3">
                    <span className="text-2xl md:text-3xl font-semibold text-gray-900">
                      {clientData.metrics.feedbackScore}
                    </span>
                    {renderStars(clientData.metrics.feedbackScore)}
                  </div>
                </div>
              </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-4">Jobs</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
                {clientData.jobs.map((job) => (
                  <div key={job.id} className="relative">
                    {job.feedbackAlert && (
                      <div
                        className={`absolute -top-2 left-0 right-0 py-1 px-2 md:px-3 text-[10px] md:text-xs font-medium text-center rounded-t-lg ${
                          job.feedbackAlert.type === "warning"
                            ? "bg-red-50 text-red-700"
                            : "bg-green-50 text-green-700"
                        }`}
                      >
                        <span className="line-clamp-1">{job.feedbackAlert.message}</span>
                      </div>
                    )}
                    <div
                      className={`bg-white border border-gray-200 rounded-lg p-3 md:p-4 ${
                        job.feedbackAlert ? "mt-6" : ""
                      }`}
                    >
                      <div className="flex items-start justify-between mb-2 md:mb-3">
                        <div className="flex items-center gap-2 md:gap-3 min-w-0 flex-1">
                          <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-purple-600 flex items-center justify-center flex-shrink-0">
                            <svg
                              className="w-4 h-4 md:w-5 md:h-5 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                              />
                            </svg>
                          </div>
                          <div className="min-w-0 flex-1">
                            <div className="flex items-center gap-1.5 md:gap-2 flex-wrap">
                              <h4 className="font-semibold text-gray-900 text-xs md:text-sm break-words">
                                {job.title}
                              </h4>
                              <span className="flex items-center gap-1 px-1.5 md:px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-[10px] md:text-xs whitespace-nowrap">
                                <span className="w-1.5 h-1.5 bg-green-600 rounded-full"></span>
                                {job.status.charAt(0).toUpperCase() +
                                  job.status.slice(1)}
                              </span>
                            </div>
                            <p className="text-[10px] md:text-xs text-gray-600 mt-0.5 md:mt-1">
                              AI Match quality: {job.aiMatchQuality}%
                            </p>
                          </div>
                        </div>
                        <button className="text-gray-400 hover:text-gray-600 flex-shrink-0">
                          <span className="text-lg md:text-xl font-bold">&#8942;</span>
                        </button>
                      </div>

                      <div className="flex flex-wrap gap-1.5 md:gap-2 mb-2 md:mb-3">
                        <div className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-xs text-gray-600">
                          <svg
                            className="w-3 h-3 md:w-4 md:h-4 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                          </svg>
                          {job.remote ? "Remote" : "On-site"}
                        </div>
                        <div className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-xs text-gray-600">
                          <svg
                            className="w-3 h-3 md:w-4 md:h-4 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          {job.jobType}
                        </div>
                        <div className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-xs text-gray-600">
                          <svg
                            className="w-3 h-3 md:w-4 md:h-4 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                            />
                          </svg>
                          {job.level}
                        </div>
                      </div>

                      <p className="text-xs md:text-sm text-gray-600 mb-2 md:mb-3 line-clamp-2">
                        {job.description}
                      </p>

                      <div className="flex items-center justify-between gap-2">
                        <span className="text-xs md:text-sm text-gray-600 break-words min-w-0">
                          {job.submissionStatus}
                        </span>
                        <button
                          onClick={() => handleSendNudge({ jobId: job.id, jobTitle: job.title })}
                          className="px-3 md:px-4 py-1 md:py-1.5 text-xs md:text-sm text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap flex-shrink-0"
                        >
                          Nudge
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-1">
            <div className="flex justify-end gap-4 mb-4">
              <button
                onClick={() => setActiveSidebarTab("company-info")}
                className={`px-4 py-2 text-sm font-medium ${
                  activeSidebarTab === "company-info"
                    ? "text-[#19bfb7]"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                Company Info
              </button>
              <button
                onClick={() => setActiveSidebarTab("contacts")}
                className={`px-4 py-2 text-sm font-medium ${
                  activeSidebarTab === "contacts"
                    ? "text-[#19bfb7]"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                Contacts
              </button>
              <button
                onClick={() => setActiveSidebarTab("financials")}
                className={`px-4 py-2 text-sm font-medium ${
                  activeSidebarTab === "financials"
                    ? "text-[#19bfb7]"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                Financials
              </button>
            </div>

            {activeSidebarTab === "company-info" && (
              <div className="space-y-4">
                <p className="text-sm text-gray-600 leading-relaxed">
                  {clientData.description}
                </p>
                <div className="space-y-3 pt-4">
                  {clientData.locations.map((location, index) => (
                    <div key={index} className="flex items-start gap-2 text-sm text-gray-600">
                      <svg className="w-4 h-4 text-gray-400 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      </svg>
                      <span>{location}</span>
                    </div>
                  ))}
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span>{clientData.employeeCount}</span>
                  </div>
                </div>
              </div>
            )}

            {activeSidebarTab === "contacts" && (
              <div className="space-y-6">
                {clientData.contacts.map((contact) => (
                  <div key={contact.id} className="flex gap-3">
                    <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                      <span className="text-gray-600 font-semibold text-sm">
                        {contact.name.split(" ").map(n => n[0]).join("")}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-semibold text-gray-900">{contact.name}</h4>
                      <p className="text-xs text-gray-600 mb-2">{contact.position}</p>
                      <div className="space-y-1">
                        {contact.emails.map((email, idx) => (
                          <div key={idx} className="flex items-center gap-2 text-xs text-gray-600">
                            <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <span className="break-all">{email}</span>
                          </div>
                        ))}
                        <div className="flex items-center gap-2 text-xs text-gray-600">
                          <svg className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                          </svg>
                          <span>{contact.phone}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {activeSidebarTab === "financials" && (
              <div className="space-y-4">
                <div>
                  <p className="text-xs text-gray-500 mb-1">Fee</p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {clientData.financials.fee}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Expected deal value</p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {clientData.financials.expectedDealValue}
                  </p>
                </div>
              </div>
            )}
            </div>
          </div>
            </>
          )}

          {activeTab === "candidateList" && (
            <>
              <div className="mb-6">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                  <div>
                    <div className="flex items-center gap-3 mb-2">
                      <h2 className="text-xl font-semibold text-gray-900">UX UI Designer</h2>
                      <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded-full">Design</span>
                    </div>
                    <p className="text-sm text-gray-600 mb-3">We're looking for a mid-level product designer to join our team.</p>
                    <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                      <div className="flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        </svg>
                        <span>Remote</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>Full-time</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                        <span>Intermediate</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                        <span>AI Match quality: 90%</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <button className="px-4 py-2 text-sm text-red-600 bg-white border border-red-300 rounded-lg hover:bg-red-50 transition-colors">
                      Close Position
                    </button>
                    <button className="px-4 py-2 text-sm text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] transition-colors">
                      Edit Job
                    </button>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {clientData.candidates.map((ca) => (
                <div key={ca.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <div className="p-4">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                          <span className="text-gray-600 font-semibold text-sm">
                            {ca.name.split(" ").map(n => n[0]).join("")}
                          </span>
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-900 text-sm">{ca.name}</h4>
                          <p className="text-xs text-gray-500">AI Match score: {ca.aiMatchScore}%</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => handleOpenCheckIn(ca)}
                          className="px-2.5 py-1 text-xs text-[#19bfb7] border border-[#19bfb7] rounded-md hover:bg-[#19bfb7] hover:text-white transition-colors"
                        >
                          Check-In
                        </button>
                        <button className="text-gray-400 hover:text-gray-600">
                          <span className="text-lg font-bold">&#8942;</span>
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <p className="text-xs text-gray-500">{ca.status}</p>
                      <p className="text-sm font-medium text-gray-900">{ca.submittedAt}</p>
                    </div>

                    <div className="flex flex-wrap gap-2 mb-4">
                      {ca.skills.map((skill, idx) => (
                        <span
                          key={idx}
                          className={`px-2 py-1 rounded text-xs font-medium ${
                            skill.type === "positive"
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          }`}
                        >
                          {skill.label}
                        </span>
                      ))}
                    </div>

                    <div className="border-t border-gray-100 pt-3">
                      {ca.activities.map((a, index) => (
                        <div key={a.id} className="flex gap-2 relative">
                          <div className="flex flex-col items-center">
                            <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 z-10">
                              <span className="text-gray-600 font-medium text-xs">
                                {a.user.split(" ").map(n => n[0]).join("")}
                              </span>
                            </div>
                            {index < ca.activities.length - 1 && (
                              <div className="w-0.5 bg-gray-200 flex-1 min-h-[20px]"></div>
                            )}
                          </div>
                          <div className="flex-1 min-w-0 pb-3">
                            <div className="flex flex-col mb-1">
  <span className="text-xs font-semibold text-gray-900">
    {a.user}
  </span>

  <span className="text-[10px] text-gray-500">
    {a.date}
  </span>

<button className="text-gray-400 hover:text-[#19bfb7] transition-colors">
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
        />
      </svg>
    </button>
</div>

                            <p className="text-xs text-gray-600 line-clamp-2">{a.text}</p>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
              ))}
            </div>
            </>
          )}

          {activeTab === "hiring-pipeline" && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="space-y-6">
                <div>
                  <h1 className="text-xl font-semibold text-gray-900 mb-2">Candidate to Client Submission</h1>
                  <p className="text-sm text-gray-500">Enter the details below to compose your submission</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Add a candidate <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={submissionForm.candidateId}
                    onChange={(e) => setSubmissionForm({ ...submissionForm, candidateId: e.target.value })}
                    className="w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent"
                  >
                    <option value="">Choose candidate</option>
                    {Array.isArray(clientData.candidates) && clientData.candidates.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name} - {c.aiMatchScore}% match
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                  className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                    dragActive ? "border-[#19bfb7] bg-teal-50" : "border-gray-300"
                  }`}
                >
                  {uploadedFile ? (
                    <div className="flex items-center justify-center gap-3">
                      <svg className="w-8 h-8 text-[#19bfb7]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span className="text-sm text-gray-700">{uploadedFile.name}</span>
                      <button onClick={removeFile} className="text-red-500 hover:text-red-700">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-gray-100 flex items-center justify-center">
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <label className="cursor-pointer">
                        <span className="text-[#19bfb7] hover:text-[#18ada6] font-medium">Click to upload</span>
                        <span className="text-gray-500"> or drag and drop</span>
                        <input type="file" className="hidden" accept=".svg,.png,.jpg,.jpeg,.gif,.pdf" onChange={handleFileInput} />
                      </label>
                      <p className="text-xs text-gray-400 mt-2">SVG, PNG, JPG or GIF (max. 800×400px)</p>
                    </>
                  )}
                </div>

                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-4">Client</h3>
                  <div className="p-4 bg-gray-50 rounded-lg mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-purple-600 flex items-center justify-center">
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">{clientData.name}</p>
                        <p className="text-xs text-gray-500">{clientData.industry}</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Role <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={submissionForm.roleId}
                      onChange={(e) => setSubmissionForm({ ...submissionForm, roleId: e.target.value })}
                      className="w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent"
                    >
                      <option value="">Choose role</option>
                      {Array.isArray(roles) && roles.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.title || role.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div>
                  <h3 className="text-sm font-semibold text-gray-900 mb-4">Formatting Options</h3>
                  <div className="space-y-3">
                    <label className="flex items-center justify-between cursor-pointer">
                      <span className="text-sm text-gray-700">Hide contact details</span>
                      <button
                        type="button"
                        onClick={() => setSubmissionForm({ ...submissionForm, hideContactDetails: !submissionForm.hideContactDetails })}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                          submissionForm.hideContactDetails ? "bg-[#19bfb7]" : "bg-gray-200"
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            submissionForm.hideContactDetails ? "translate-x-6" : "translate-x-1"
                          }`}
                        />
                      </button>
                    </label>

                    <label className="flex items-center justify-between cursor-pointer">
                      <span className="text-sm text-gray-700">Include shortlist link</span>
                      <button
                        type="button"
                        onClick={() => setSubmissionForm({ ...submissionForm, includeShortlistLink: !submissionForm.includeShortlistLink })}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                          submissionForm.includeShortlistLink ? "bg-[#19bfb7]" : "bg-gray-200"
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            submissionForm.includeShortlistLink ? "translate-x-6" : "translate-x-1"
                          }`}
                        />
                      </button>
                    </label>
                  </div>
                </div>
              </div>

              <div className="flex flex-col">
                <div className="flex-1 bg-gray-100 rounded-xl overflow-hidden min-h-[300px] flex items-center justify-center p-8">
                  {submissionForm.candidateId ? (
                    (() => {
                      const selectedCandidate = clientData.candidates?.find(c => c.id === parseInt(submissionForm.candidateId));
                      return selectedCandidate ? (
                        <div className="text-center">
                          <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-gray-200 flex items-center justify-center">
                            <span className="text-2xl font-semibold text-gray-600">
                              {selectedCandidate.name.split(" ").map(n => n[0]).join("")}
                            </span>
                          </div>
                          <h3 className="text-lg font-semibold text-gray-900">{selectedCandidate.name}</h3>
                          <p className="text-sm text-gray-500">AI Match: {selectedCandidate.aiMatchScore}%</p>
                          <div className="flex flex-wrap justify-center gap-2 mt-3">
                            {selectedCandidate.skills?.map((skill, idx) => (
                              <span
                                key={idx}
                                className={`px-2 py-1 rounded text-xs font-medium ${
                                  skill.type === "positive" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                                }`}
                              >
                                {skill.label}
                              </span>
                            ))}
                          </div>
                        </div>
                      ) : null;
                    })()
                  ) : (
                    <div className="h-full flex items-center justify-center">
                      <img
                        src={CandidateSubmissionImage}
                        alt="Preview"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                </div>

                <div className="flex gap-3 mt-6 justify-end">
                  <button
                    onClick={() => {
                      setSubmissionForm({ candidateId: '', roleId: '', hideContactDetails: true, includeShortlistLink: true });
                      setUploadedFile(null);
                    }}
                    className="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmission}
                    disabled={submitting || !submissionForm.roleId}
                    className="px-6 py-2.5 text-sm font-medium text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {submitting ? "Sending..." : "Send"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showNudgeModal && (
        <div className="fixed inset-0 bg-gray-900/30 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl w-full max-w-md">
            <div className="p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Nudge</h3>
                    <p className="text-sm text-gray-500">Enter your remarks below and send</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowNudgeModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="flex items-center gap-3 mb-4 p-3 bg-gray-50 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-purple-600 flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">{clientData.name}</p>
                  <p className="text-xs text-gray-500">{clientData.industry}</p>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={nudgeMessage}
                  onChange={(e) => setNudgeMessage(e.target.value)}
                  placeholder="Enter your message here..."
                  rows={4}
                  className="w-full px-3 py-2 text-sm text-gray-900 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent resize-none"
                />
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => sendNudge("in-app")}
                  disabled={!nudgeMessage.trim() || sendingNudge}
                  className="flex-1 px-4 py-2.5 text-sm font-medium text-[#19bfb7] border border-[#19bfb7] rounded-lg hover:bg-[#19bfb7] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Send via In-app Message
                </button>
                <button
                  onClick={() => sendNudge("email")}
                  disabled={!nudgeMessage.trim() || sendingNudge}
                  className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Send via Email
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCheckInModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setShowCheckInModal(false)}
          />
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-6">
            <button
              onClick={() => setShowCheckInModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="text-center mb-6">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#19bfb7]/10 flex items-center justify-center">
                <svg className="w-6 h-6 text-[#19bfb7]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-900">Check-In Message</h2>
              <p className="text-sm text-gray-500 mt-1">Review and send message</p>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Subject <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={checkInData.subject}
                  onChange={(e) => setCheckInData({ ...checkInData, subject: e.target.value })}
                  placeholder="Enter subject"
                  className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={checkInData.message}
                  onChange={(e) => setCheckInData({ ...checkInData, message: e.target.value })}
                  placeholder="Write your message here..."
                  rows={4}
                  className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#19bfb7] focus:border-transparent resize-none"
                />
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => sendCheckIn(true)}
                disabled={!checkInData.subject.trim() || !checkInData.message.trim() || sendingCheckIn}
                className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Schedule for later
              </button>
              <button
                onClick={() => sendCheckIn(false)}
                disabled={!checkInData.subject.trim() || !checkInData.message.trim() || sendingCheckIn}
                className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {sendingCheckIn ? "Sending..." : "Send Now"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientDetail;
